import NavFonts from "@/react/story/components/navs/NavFonts";
import NavHeader from "@/react/story/components/navs/NavHeader";
import NavLocales from "@/react/story/components/navs/NavLocales";
import NavPages from "@/react/story/components/navs/NavPages";

export default function Nav() {
    return (
        <>
            <NavHeader />
            <NavLocales />
            <NavPages />
            <NavFonts />
        </>
    );
}
